<script lang="ts">
  /** Default: `lg:w-1/2` */
  export let leadWidth = 'lg:w-1/2';
  /** Default: `lg:w-1/2` */
  export let trailWidth = 'lg:w-1/2';
</script>

<div class="flex flex-col lg:flex-row">
  <div class={leadWidth}>
    <slot name="lead" />
  </div>

  <span class="divider-vertical mx-10 hidden lg:block"></span>
  <hr class="my-10 block lg:hidden" />

  <div class={trailWidth}>
    <slot name="trail" />
  </div>
</div>
